import { Stack, FormControlLabel, Checkbox } from '@mui/material'
import type { Group } from './dataPipeline'

interface Props {
  groups: Group[]
  inactiveSeries: string[]
  onChange: (next: string[]) => void
}

export function ChartLegend({ groups, inactiveSeries, onChange }: Props) {
  const toggle = (key: string) => {
    if (inactiveSeries.includes(key)) {
      onChange(inactiveSeries.filter((k) => k !== key))
    } else {
      onChange([...inactiveSeries, key])
    }
  }

  // Wave-4 rider #5 (dataviz: one series needs no legend box; a lone toggle-off only
  // empties the chart). Escape hatch: a URL-persisted inactive lone series still shows
  // its checkbox so the user can recover without Reset Settings — never a dead end.
  if (groups.length < 2 && inactiveSeries.length === 0) return null

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {groups.map((g) => (
        <FormControlLabel
          key={g.key}
          label={g.label}
          control={
            <Checkbox
              checked={!inactiveSeries.includes(g.key)}
              onChange={() => toggle(g.key)}
              sx={{ color: g.color.hex, '&.Mui-checked': { color: g.color.hex } }}
              name={g.key}
            />
          }
        />
      ))}
    </Stack>
  )
}
